import type { Theme } from '@mui/material'
import type { ImageUrlBuilder } from '@sanity/image-url/lib/types/builder'

export const getResponsiveBackgroundImage = (image: ImageUrlBuilder | undefined, theme: Theme) => {
  if (!image) {
    return undefined
  }

  const backgroundImageAt = (width: number) => `url(${image.width(width).auto('format').url()})`
  const { sm, md, lg, xl } = theme.breakpoints.values

  return {
    xs: backgroundImageAt(sm),
    md: backgroundImageAt(md),
    lg: backgroundImageAt(lg),
    xl: backgroundImageAt(xl),
  }
}

/** Same breakpoint widths as getResponsiveBackgroundImage, as an `imageSrcSet` for ReactDOM.preload. */
export const getResponsiveImageSrcSet = (image: ImageUrlBuilder | undefined, theme: Theme) => {
  if (!image) {
    return undefined
  }

  const { sm, md, lg, xl } = theme.breakpoints.values

  return [sm, md, lg, xl].map((width) => `${image.width(width).auto('format').url()} ${width}w`).join(', ')
}
